import DualListBox from './js/DualListBox'

export { DualListBox }
export default DualListBox
